import {UteTariffInterface} from './uteTariffInterface';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UteTariff implements UteTariffInterface{
  rs = [9.357, 0, 0];
  gs = [6.897, 0, 0];
  mc1 = [2.15, 4.732, 10.765];
  mc2 = [2.057, 4.281, 7.565];
  mc3 = [2.045, 4.27, 6.745];
  gc1 = [2.078, 3.753, 11.29];
  gc2 = [2.048, 3.537, 8.122];

  private static getIndex(chargingSchedule: string): number {
    return chargingSchedule === 'valley' ? 0 : chargingSchedule === 'flat' ? 1 : 2;
  }


  getEnergyCost(uteTariff: string, chargingSchedule: string): number {
    return this[uteTariff as keyof UteTariffInterface][UteTariff.getIndex(chargingSchedule)];
  }
}
